/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn } from "@reduxjs/toolkit/query";

import axios from "connection";

import getDeeplinkToken from "utils/getDeeplinkToken";

import getStateFromUrl from "utils/getStateFromUrl";

import { API_URL, PPE_PATH } from "config";
import { setOffersLoaded } from "state/offers-slice";
import { setModal } from "state/config-slice";
import getMagiclinkToken from "utils/getMagiclinkToken";

const getOffersUrl = (): string => {
  const tokenParams = getDeeplinkToken() || getMagiclinkToken();

  return `${API_URL}${PPE_PATH}/offers?${tokenParams}${getStateFromUrl()}`;
};

const customBaseQuery =
  ({ baseUrl }: { baseUrl: string } = { baseUrl: "" }): BaseQueryFn =>
  async () => {
    try {
      const result = await axios.get(baseUrl || getOffersUrl(), {
        headers: {
          "page-source": window.location.pathname,
        },
      });

      return result;
    } catch (error: any) {
      return Promise.reject({
        error,
        errorCode: error?.response?.data?.errorCode,
      });
    }
  };

const commonBaseQuery = customBaseQuery({
  baseUrl: "",
});

const offersBaseQuery: BaseQueryFn = async (args, api, extraOptions) => {
  try {
    return await commonBaseQuery(args, api, extraOptions);
  } catch (err: any) {
    return {
      error: {
        status: err?.error?.response?.status ?? 500,
        data: err?.error?.response?.data,
        errorCode: err?.errorCode,
      },
    };
  }
};

export const offersApi = createApi({
  reducerPath: "offersApi",
  baseQuery: offersBaseQuery,
  endpoints: (builder) => ({
    getOffers: builder.query({
      query: () => true,
      onQueryStarted: async (_, api) => {
        const { dispatch, queryFulfilled } = api;

        try {
          const { data } = await queryFulfilled;
          if (data.redirectUrl) {
            window.location.replace(data.redirectUrl);
          } else if (data) {
            dispatch(setOffersLoaded(true));
          }
        } catch (err: any) {
          console.error("errorCode", err?.error?.errorCode || "No error code");
          dispatch(
            setModal({
              showModal: true,
              errorModal: true,
              errorCode: err?.error?.errorCode || "Oops! Technical error",
            }),
          );
        }
      },
    }),
  }),
});

export const { useGetOffersQuery } = offersApi;
